import { render, staticRenderFns } from "./HoraActual.vue?vue&type=template&id=9025f5c2&"
import script from "./HoraActual.vue?vue&type=script&lang=js&"
export * from "./HoraActual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports